import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Typography from "@mui/joy/Typography";

interface FormTextFieldProps {
    name: string;
    label: string;
    placeholder?: string;
    rules?: object;
    type?: string;
    helperText?: string;
    startDecorator?: any;
    size?: "sm" | "md" | "lg";
    disabled?: boolean;
    sx?: any;
}

const TextField: React.FC<FormTextFieldProps> = ({
    name,
    label,
    placeholder,
    rules = {},
    type = "text",
    helperText,
    size = "md",
    disabled,
    sx,
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <FormControl error={!!fieldState.error} size={size}>
                    <FormLabel>{label}</FormLabel>
                    {helperText && !fieldState.error && (
                        <Typography level="body-xs" sx={{ color: "text.secondary", mb: 1, mt: -0.7 }}>
                            {helperText}
                        </Typography>
                    )}
                    {fieldState.error && (
                        <Typography level="body-xs" color="danger" sx={{ mb: 1, mt: -0.7 }}>
                            {fieldState.error.message}
                        </Typography>
                    )}
                    <Input {...field} placeholder={placeholder} type={type} disabled={disabled} sx={sx} {...props} />
                </FormControl>
            )}
        />
    );
};

export default TextField;
